import React, { Component } from 'react';
import { startTimer, stopTimer } from '../api/timer'
import TimeField from 'react-simple-timefield';
import moment from 'moment-jalaali'

class Timercounter extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      s : '00',
      m : '00',
      h : '0',
      start : false,
      open : false,
      time1: ''
    }
  }
  
  componentWillReceiveProps = (nextProps, nextState) => {
    if(nextProps.active.start && this.state.start === false){
      this.setState({ start : true })
      startTimer(this)
      this.startInput = moment(nextProps.active.start).locale('en').format('HH:mm')
    }
    if(this.state.open && !nextProps.active.start){
      this.setState({open: false})
    }
  }

  componentWillMount = ()=>{
    if(this.props.active.start && this.state.start === false){
      this.setState({ start : true })
      startTimer(this)
    }
  }

  componentWillUnmount = ()=>{
    stopTimer(this)
  }

  toggleDetail = ()=>{
    if(this.props.active.start){
      this.setState({open: !this.state.open})
    }
  }

  handleSubmit = (e)=>{
    e.preventDefault();
    if( this.startInput !== moment(this.props.active.start).locale('en').format('HH:mm')){
      this.props.updateActiveRecordStart(this.startInput, this.props.active)
    }
  }
  render() {
    return (
      <div className="timer">
        <div onClick={this.toggleDetail.bind(this)}>
          {this.state.h}:{this.state.m}:{this.state.s}
        </div>
        {(this.state.open) ? (
          <div>
            <div className="detail-overlayer" onClick={this.toggleDetail.bind(this)}></div>
            <div className="counter-detail">
              <div className="pull-right">
                <h6>شروع
                  {' '}
                  <i>
                    ({moment(this.props.active.start).format('jD jMMMM')})
                  </i>
                </h6>
                <form onSubmit={this.handleSubmit}>
                  <TimeField value={this.startInput} onChange={(value)=>{this.startInput=value}} onBlur={this.handleSubmit} />
                </form>
              </div>
              <div className="pull-left">
                <h6>پایان</h6>
                <input type="text" value={this.state.endTime} disabled/>
              </div>
            </div>
          </div>
        ):(null)}
      </div>
    );
  }
}
Timercounter.defaultProps = {
  active : {
    start : ''
  }
}
export default Timercounter;
